import type { SxProps, Theme } from '@mui/material';

const baseContainer = {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
} as const;

export const styles = {
    container: baseContainer as SxProps<Theme>,
    fullScreenContainer: {
        ...baseContainer,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
    } as SxProps<Theme>,
    message: { fontWeight: 500 } as SxProps<Theme>,
};
